// =================================================================
// ARQUIVO: src/Routes/CvRoutes.js (Completo e Reescrito)
// =================================================================
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import themeCv from '../components/Products/Cv/themeCv';
import CvAdminLayout from '../components/Products/Cv/pages/CvAdminLayout';
import Home from '../components/Products/Cv/pages/Home';
import Jobs from '../components/Products/Cv/pages/Jobs';
import Forms from '../components/Products/Cv/pages/Forms';
import Applications from '../components/Products/Cv/pages/Applications';
import Tutorial from '../components/Products/Cv/pages/Tutorial';

const CvRoutes = () => (
  <ThemeProvider theme={themeCv}>
    <Routes>
      {/* O CvAdminLayout agora envolve todas as rotas de admin */}
      <Route element={<CvAdminLayout />}>
        {/* A rota "/" dentro deste grupo corresponde a "/cv" no App.js */}
        <Route path="/" element={<Home />} />

        {/* Módulos */}
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/etapas" element={<Forms />} />
        <Route path="/applications" element={<Applications />} />
        <Route path="/tutorial" element={<Tutorial />} />
      </Route>
    </Routes>
  </ThemeProvider>
);

export default CvRoutes;
